import React, { useContext } from 'react';
import * as ls from './GenericPortalLayout.less';
import { Fa } from '../Fa';
import { Row, Col, Button, Tooltip } from 'antd';
import { faPhone, faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import { faComment } from '@fortawesome/free-regular-svg-icons';
import Layout from 'antd/lib/layout';
import Icon from 'antd/lib/icon';
import { GlobalStateContext } from '../../../context/GlobalStateProvider';
import {navigate, navigateToHome} from '../../../navigation/navigationHistory';
import Logo from '../../svg/LogoSVG';
import FacebookSVG from '../../svg/FacebookSVG';
import InstagramSVG from '../../svg/InstagramSVG';
import TwitterSVG from '../../svg/TwitterSVG';
import YouTubeSVG from '../../svg/YouTubeSVG';
import { version, build, buildOutVersion, buildOutBuild } from '../../../../../package.json';
import {ConfigContext} from 'portal-core/components/PortalApp';
import {getAge} from "../../../utils/dateUtils";
import {GA_CONFIGURATION, sendGoogleAnalyticsEvent} from "../../../utils/googleAnalyticsUtils";

export function GenericPortalLayout({
  contactPhoneNumber,
  contactPhoneNumberDisplay,
  liveChatNow,
  children,
}) {
  const { isDesktop, isTablet, isMobile } = useContext(GlobalStateContext);

  const config = useContext(ConfigContext);
  // Privacy Link
  const showPrivacyPolicy = config.branding.companyLinks.privacyPolicy.showInd;
  const showPrivacyPolicyText = config.branding.companyLinks.privacyPolicy.text;
  const showPrivacyPolicyLink = config.branding.companyLinks.privacyPolicy.href;
  // Legal Notes Link
  const showLegalNotes = config.branding.companyLinks.legalNotes.showInd;
  const showLegalNotesText = config.branding.companyLinks.legalNotes.text;
  const showLegalNotesLink = config.branding.companyLinks.legalNotes.href;
  // Contact Us
  const showContactUs = config.branding.companyLinks.contactUs.showInd;
  const showContactUsText = config.branding.companyLinks.contactUs.text;
  const showContactUsLink = config.branding.companyLinks.contactUs.href;
  // Find Agent
  const showFindAgent = config.branding.companyLinks.findAgent.showInd;
  const showFindAgentText = config.branding.companyLinks.findAgent.text;
  const showFindAgentLink = config.branding.companyLinks.findAgent.href;

  // Social Media configurations
  const showFacebook = config.branding.socialMediaLinks.facebook.showFacebook;
  const showFacebookLink = config.branding.socialMediaLinks.facebook.href;
  const showInstagram = config.branding.socialMediaLinks.instagram.showInstagram;
  const showInstagramLink = config.branding.socialMediaLinks.instagram.href;
  const showTwitter = config.branding.socialMediaLinks.twitter.showTwitter;
  const showTwitterLink = config.branding.socialMediaLinks.twitter.href;
  const showYoutube = config.branding.socialMediaLinks.youtube.showYoutube;
  const showYoutubeLink = config.branding.socialMediaLinks.youtube.href;

  let versionBuild = version + '-' + build;
  if (buildOutVersion && buildOutBuild && buildOutVersion.length > 0 && buildOutBuild.length > 0) {
    versionBuild = buildOutVersion + '-' + buildOutBuild + ' (' + versionBuild + ')';
  }

  const urlParams = new URLSearchParams(window.location.search);
  const utmSource = urlParams.get('utm_source');
  const influencerId = urlParams.get('influencer_id');
  if (!sessionStorage.getItem("b1_sales_lead_source") || !sessionStorage.getItem("b1_sales_influencer_id")){
    if (utmSource != undefined)
      sessionStorage.setItem("b1_sales_lead_source", utmSource);
    if (influencerId != undefined)
      sessionStorage.setItem("b1_sales_influencer_id", influencerId);
  }
  if (utmSource != undefined || influencerId != undefined){
    if (utmSource != undefined)
      urlParams.delete('utm_source');
    if (influencerId != undefined)
      urlParams.delete('influencer_id');
    window.location.search = urlParams.toString();
    window.history.pushState({}, document.title, "/");
  }

  let influencerChanges = false;
  if (sessionStorage.getItem('b1_sales_influencer_id') == config.branding.influencer1.id) {
    influencerChanges = true;
    contactPhoneNumber.displayPhoneNumber = config.branding.influencer1.phoneNumber;
  }

  let mainLogoRef = "main-logo.svg";
  let partnerLogoRef = "partner-logo.svg"
  let mobileLogoRef = "mobile-logo.svg";

  const navigateToFAQ = ()=>{
    navigate(`/faq`);
    sendGoogleAnalyticsEvent({...GA_CONFIGURATION.FAQ});
  }

  if (!influencerChanges) {
      return (
        <div className={ls.mainLayout}>
          <header>
            <div
              className={ls.headerLogo}
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
              onClick={() => navigateToHome()}
            >
              {!isMobile ? (
                  <Logo file={mainLogoRef} width={300} height={115}/>
              ) : (
                  <Logo file={mobileLogoRef} width={200} height={115}/>
              )}
            </div>
            <HeaderInfoBlock
              top={isDesktop ? 'Frequently Asked Questions' : ''}
              bottom={
                <React.Fragment>
                  {isDesktop ? (
                    <Button
                      aria-label="Link to FAQ"
                      ghost
                      type="link"
                      style={{ color: 'white', fontSize: '16px', fontWeight: 'normal' }}
                      size={"small"}
                      onClick={() => navigateToFAQ()}
                    >
                      <Fa
                        aria-label="Question Icon"
                        icon={faQuestionCircle}
                        style={{ marginRight: '4px' }}
                      />{' '}
                      Check Answers
                    </Button>
                  ) : (
                    <Button
                      aria-label="Go to FAQ"
                      ghost
                      type="link"
                      style={{ color: 'white' }}
                      size={"small"}
                      onClick={() => navigateToFAQ()}
                    >
                      <Fa icon={faQuestionCircle} aria-label="Question Icon" />
                    </Button>
                  )}
                </React.Fragment>
              }
            />
            <HeaderInfoBlock
              top={isDesktop && contactPhoneNumber && contactPhoneNumber.enabled ? `${contactPhoneNumber.supportText}` : ''}
              bottom={
                <React.Fragment>
                  {
                    contactPhoneNumber.enabled ?
                      (
                        isDesktop ?  (
                          <a aria-label= {contactPhoneNumber.assistiveText} href={`tel: ${contactPhoneNumber.displayPhoneNumber}`}>
                            <Fa aria-label={contactPhoneNumber.iconLabel} icon={faPhone}  />{' '}
                            {contactPhoneNumber.displayPhoneNumber}
                          </a>
                        ) :
                        (
                          <a aria-label= {contactPhoneNumber.assistiveText} href={`tel: ${contactPhoneNumber.displayPhoneNumber}`}>
                            <Fa aria-label={contactPhoneNumber.iconLabel} icon={faPhone}  />{' '}
                          </a>
                        )
                      )
                      : ''
                  }
                </React.Fragment>
              }
            />
            <HeaderInfoBlock
              top={isDesktop && liveChatNow && liveChatNow.chatEnabled ? `${liveChatNow.supportText}` : ''}
              bottom={
                <React.Fragment>
                  {liveChatNow.chatEnabled ?
                    (
                      isDesktop ?
                        <a aria-label= {liveChatNow.chatLabel} href={liveChatNow.href}>
                          <Fa icon={faComment} aria-label={liveChatNow.iconLabel} />
                          {liveChatNow.displayTextValue}
                        </a>
                      :
                        <a aria-label={liveChatNow.chatLabel} href={liveChatNow.href}>
                          <Fa icon={faComment} />
                        </a>
                    )
                    :  ''
                  }
                </React.Fragment>
              }
            />
          </header>

          <main className={ls.middle}>{children}</main>
          <footer>
            {isDesktop ? (
              <>
                <nav>
                  <CompanyLink isDesktop={isDesktop} showInd={showPrivacyPolicy} text={showPrivacyPolicyText} href={showPrivacyPolicyLink}/>
                  <CompanyLink isDesktop={isDesktop} showInd={showLegalNotes} text={showLegalNotesText} href={showLegalNotesLink}/>
                  <CompanyLink isDesktop={isDesktop} showInd={showContactUs} text={showContactUsText} href={showContactUsLink}/>
                  <CompanyLink isDesktop={isDesktop} showInd={showFindAgent} text={showFindAgentText} href={showFindAgentLink}/>
                </nav>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    marginLeft: 'auto',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'flex-end',
                    }}
                  >
                    <div
                      style={{
                        width: '100px',
                        display: 'flex',
                        justifyContent: 'space-between',
                      }}
                    >
                      {showFacebook ? (
                        <a aria-label="Link to Facebook" href={showFacebookLink} target="_blank">
                          <FacebookSVG aria-label="Facebook icon" />
                        </a>
                      ) : (
                        ''
                      )}
                      {showInstagram ? (
                        <a aria-label="Link to Instagram" href={showInstagramLink} target="_blank">
                          <InstagramSVG aria-label="Instagram icon" />
                        </a>
                      ) : (
                        ''
                      )}
                      {showTwitter ? (
                        <a aria-label="Link to Twitter" href={showTwitterLink} target="_blank">
                          <TwitterSVG aria-label="Twitter icon" />
                        </a>
                      ) : (
                        ''
                      )}
                      {showYoutube ? (
                        <a aria-label="Link to YouTube" href={showYoutubeLink} target="_blank">
                          <YouTubeSVG aria-label="YouTube icon" />
                        </a>
                      ) : (
                        ''
                      )}
                    </div>
                  </div>
                  <Tooltip title={versionBuild} mouseEnterDelay={0.5}>
                    <span className={ls.copyright}>
                      Copyright © 2001-{new Date().getFullYear()} Guidewire Software
                    </span>
                  </Tooltip>
                </div>
              </>
            ) : (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <div>
                  <Row>
                    <Col span={24}>
                      <div
                        style={{
                          width: '100px',
                          display: 'flex',
                          justifyContent: 'space-between',
                        }}
                      >
                        {showFacebook ? (
                          <a aria-label="Link to Facebook" href={showFacebookLink} target="_blank">
                            <FacebookSVG aria-label="Facebook icon" />
                          </a>
                        ) : (
                          ''
                        )}
                        {showInstagram ? (
                          <a aria-label="Link to Instagram" href={showInstagramLink} target="_blank">
                            <InstagramSVG aria-label="Instagram icon" />
                          </a>
                        ) : (
                          ''
                        )}
                        {showTwitter ? (
                          <a aria-label="Link to Twitter" href={showTwitterLink} target="_blank">
                            <TwitterSVG aria-label="Twitter icon" />
                          </a>
                        ) : (
                          ''
                        )}
                        {showYoutube ? (
                          <a aria-label="Link to YouTube" href={showYoutubeLink} target="_blank">
                            <YouTubeSVG aria-label="YouTube icon" />
                          </a>
                        ) : (
                          ''
                        )}
                      </div>
                    </Col>
                  </Row>
                </div>

                <div
                  style={{
                    width: '250px',
                    marginTop: '20px',
                  }}
                >
                  <Row>
                    <CompanyLink isDesktop={isDesktop} showInd={showPrivacyPolicy} text={showPrivacyPolicyText} href={showPrivacyPolicyLink}/>
                    <CompanyLink isDesktop={isDesktop} showInd={showLegalNotes} text={showLegalNotesText} href={showLegalNotesLink}/>
                  </Row>
                  <Row
                    style={{
                      marginTop: '20px',
                    }}
                  >
                    <CompanyLink isDesktop={isDesktop} showInd={showContactUs} text={showContactUsText} href={showContactUsLink}/>
                    <CompanyLink isDesktop={isDesktop} showInd={showFindAgent} text={showFindAgentText} href={showFindAgentLink}/>
                  </Row>
                </div>

                <div
                  style={{
                    marginTop: '15px',
                  }}
                >
                  <Tooltip title={versionBuild} trigger="click">
                    <span className={ls.copyright}>
                      Copyright © 2001-{new Date().getFullYear()} Guidewire Software
                    </span>
                  </Tooltip>
                </div>
              </div>
            )}
          </footer>
        </div>
      );
  } else {
    return (
      <div className={ls.mainLayout}>
        <header
          style={{
            background: '#63666A',
            padding: '0px 0px'
          }}
        >
          <div
            className={ls.headerLogo}
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              marginLeft: '0px'
            }}
            onClick={() => navigateToHome()}
          >
            {!isMobile ? (
                <Logo file={partnerLogoRef} width={450} height={105}/>
            ) : (
                <Logo file={partnerLogoRef} width={250} height={105}/>
            )}
          </div>
          <HeaderInfoBlock
            top={isDesktop ? 'Frequently Asked Questions' : ''}
            bottom={
              <React.Fragment>
                {isDesktop ? (
                  <Button
                    aria-label="Link to FAQ"
                    ghost
                    type="link"
                    style={{ color: 'white', fontSize: '16px', fontWeight: 'normal' }}
                    size={"small"}
                    onClick={() => navigateToFAQ()}
                  >
                    <Fa
                      aria-label="Question Icon"
                      icon={faQuestionCircle}
                      style={{ marginRight: '4px' }}
                    />{' '}
                    Check Answers
                  </Button>
                ) : (
                  <Button
                    aria-label="Go to FAQ"
                    ghost
                    type="link"
                    style={{ color: 'white' }}
                    size={"small"}
                    onClick={() => navigateToFAQ()}
                  >
                    <Fa icon={faQuestionCircle} aria-label="Question Icon" />
                  </Button>
                )}
              </React.Fragment>
            }
          />
          <HeaderInfoBlock
            top={isDesktop && contactPhoneNumber && contactPhoneNumber.enabled ? `${contactPhoneNumber.supportText}` : ''}
            bottom={
              <React.Fragment>
                {
                  contactPhoneNumber.enabled ?
                    (
                      isDesktop ?  (
                        <a aria-label= {contactPhoneNumber.assistiveText} href={`tel: ${contactPhoneNumber.displayPhoneNumber}`}>
                          <Fa aria-label={contactPhoneNumber.iconLabel} icon={faPhone}  />{' '}
                          {contactPhoneNumber.displayPhoneNumber}
                        </a>
                      ) :
                      (
                        <a aria-label= {contactPhoneNumber.assistiveText} href={`tel: ${contactPhoneNumber.displayPhoneNumber}`}>
                          <Fa aria-label={contactPhoneNumber.iconLabel} icon={faPhone}  />{' '}
                        </a>
                      )
                    )
                    : ''
                }
              </React.Fragment>
            }
          />
          <HeaderInfoBlock
            top={isDesktop && liveChatNow && liveChatNow.chatEnabled ? `${liveChatNow.supportText}` : ''}
            bottom={
              <React.Fragment>
                {liveChatNow.chatEnabled ?
                  (
                    isDesktop ?
                      <a aria-label= {liveChatNow.chatLabel} href={liveChatNow.href}>
                        <Fa icon={faComment} aria-label={liveChatNow.iconLabel} />
                        {liveChatNow.displayTextValue}
                      </a>
                    :
                      <a aria-label={liveChatNow.chatLabel} href={liveChatNow.href}>
                        <Fa icon={faComment} />
                      </a>
                  )
                  :  ''
                }
              </React.Fragment>
            }
          />
        </header>

        <main className={ls.middle}>{children}</main>
        <footer
          style={{
            background: '#63666A'
          }}
        >
          {isDesktop ? (
            <>
              <nav>
                <CompanyLink isDesktop={isDesktop} showInd={showPrivacyPolicy} text={showPrivacyPolicyText} href={showPrivacyPolicyLink}/>
                <CompanyLink isDesktop={isDesktop} showInd={showLegalNotes} text={showLegalNotesText} href={showLegalNotesLink}/>
                <CompanyLink isDesktop={isDesktop} showInd={showContactUs} text={showContactUsText} href={showContactUsLink}/>
                <CompanyLink isDesktop={isDesktop} showInd={showFindAgent} text={showFindAgentText} href={showFindAgentLink}/>
              </nav>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  marginLeft: 'auto',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'flex-end',
                  }}
                >
                  <div
                    style={{
                      width: '100px',
                      display: 'flex',
                      justifyContent: 'space-between',
                    }}
                  >
                  </div>
                </div>
                <Tooltip title={versionBuild} mouseEnterDelay={0.5}>
                  <span className={ls.copyright}>
                    Copyright © 2001-{new Date().getFullYear()} Guidewire Software
                  </span>
                </Tooltip>
              </div>
            </>
          ) : (
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <div>
                <Row>
                  <Col span={24}>
                    <div
                      style={{
                        width: '100px',
                        display: 'flex',
                        justifyContent: 'space-between',
                      }}
                    >
                    </div>
                  </Col>
                </Row>
              </div>

              <div
                style={{
                  width: '250px',
                  marginTop: '20px',
                }}
              >
                <Row>
                  <CompanyLink isDesktop={isDesktop} showInd={showPrivacyPolicy} text={showPrivacyPolicyText} href={showPrivacyPolicyLink}/>
                  <CompanyLink isDesktop={isDesktop} showInd={showLegalNotes} text={showLegalNotesText} href={showLegalNotesLink}/>
                </Row>
                <Row
                  style={{
                    marginTop: '20px',
                  }}
                >
                  <CompanyLink isDesktop={isDesktop} showInd={showContactUs} text={showContactUsText} href={showContactUsLink}/>
                  <CompanyLink isDesktop={isDesktop} showInd={showFindAgent} text={showFindAgentText} href={showFindAgentLink}/>
                </Row>
              </div>

              <div
                style={{
                  marginTop: '15px',
                }}
              >
                <Tooltip title={versionBuild} trigger="click">
                  <span className={ls.copyright}>
                    Copyright © 2001-{new Date().getFullYear()} Guidewire Software
                  </span>
                </Tooltip>
              </div>
            </div>
          )}
        </footer>
      </div>
    );
      }
}

function HeaderInfoBlock({ top, bottom }) {
  return (
    <div className={ls.headerInfoBlock}>
      <div className={ls.top}>{top}</div>
      <div className={ls.bottom}>{bottom}</div>
    </div>
  );
}

function CompanyLink({ isDesktop, showInd, text, href }) {
  if (!showInd) return null;
  const helpText = 'Link to ' + text.toLowerCase();
  if (isDesktop) {
    return (
        <a aria-label={helpText} href={href} target="_blank">
          {text}
        </a>
    )
  } else {
    return (
        <Col span={12}>
          <a aria-label={helpText} href={href}>
            {text}
          </a>
        </Col>
    )
  }
}